
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "128px",
    "height": "128px",
    "viewBox": "0 0 128 128",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "icon/ns-icon-query-light"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icon/ns-icon-query-light",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "search"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形",
                "x": "0",
                "y": "0",
                "width": "128",
                "height": "128"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M118.390773,105.097416 L116.102809,102.816353 L98.2310172,84.9119941 L98.2310187,84.9119919 C113.44688,62.3089787 107.467131,31.6448123 84.8750088,16.4217405 C62.2828643,1.19855924 31.6334427,7.18118443 16.4176909,29.7841757 C1.2018297,52.3871889 7.18157815,83.0513553 29.7737008,98.2744271 C46.4823878,109.533139 68.3554685,109.493409 85.0232412,98.1741611 L105.143023,118.37564 L105.143023,118.37564 C107.308014,120.541453 110.817927,120.541453 112.982918,118.37564 L118.430846,112.91709 L118.430846,112.91709 C120.538492,110.730678 120.520748,107.262156 118.390846,105.097436 L118.390773,105.097416 Z M87.1911955,69.5528003 L87.1911961,69.5527989 C80.3269872,86.1430008 61.319889,94.0247668 44.7376645,87.1572667 C28.15544,80.2897556 20.2774639,61.2735134 27.1416619,44.6833115 C34.0058707,28.0931096 53.0129689,20.2113436 69.5951934,27.0788438 C73.5434802,28.714026 77.1306488,31.1122552 80.1513291,34.1362493 L80.1513292,34.1362494 C89.4717101,43.4145654 92.2542012,57.4127035 87.1912399,69.5528099 L87.1911955,69.5528003 Z",
                "id": "形状",
                "fill": "#0890F2",
                "fill-rule": "nonzero"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  